import * as T from './redux.actionTypes';

export const fetchTeams = (params) => ({ type: T.FETCH_TEAMS, payload: params });
export const fetchTeamsSuccess = (payload) => ({ type: T.FETCH_TEAMS_SUCCESS, payload });
export const fetchTeamsFailure = (error) => ({ type: T.FETCH_TEAMS_FAILURE, payload: error });

export const fetchTeamDetail = (id) => ({ type: T.FETCH_TEAM_DETAIL, payload: { id } });
export const fetchTeamDetailSuccess = (payload) => ({ type: T.FETCH_TEAM_DETAIL_SUCCESS, payload });
export const fetchTeamDetailFailure = (error) => ({ type: T.FETCH_TEAM_DETAIL_FAILURE, payload: error });
export const clearTeamDetail = () => ({ type: T.CLEAR_TEAM_DETAIL });

export const createTeam = (payload) => ({ type: T.CREATE_TEAM, payload });
export const createTeamSuccess = (payload) => ({ type: T.CREATE_TEAM_SUCCESS, payload });
export const createTeamFailure = (error) => ({ type: T.CREATE_TEAM_FAILURE, payload: error });

export const updateTeam = (id, data) => ({ type: T.UPDATE_TEAM, payload: { id, data } });
export const updateTeamSuccess = (payload) => ({ type: T.UPDATE_TEAM_SUCCESS, payload });
export const updateTeamFailure = (error) => ({ type: T.UPDATE_TEAM_FAILURE, payload: error });

export const deleteTeam = (id) => ({ type: T.DELETE_TEAM, payload: { id } });
export const deleteTeamSuccess = (id) => ({ type: T.DELETE_TEAM_SUCCESS, payload: { id } });
export const deleteTeamFailure = (error) => ({ type: T.DELETE_TEAM_FAILURE, payload: error });

export const addMember = (teamId, data) => ({ type: T.ADD_MEMBER, payload: { teamId, data } });
export const addMemberSuccess = (member) => ({ type: T.ADD_MEMBER_SUCCESS, payload: member });
export const updateMember = (teamId, email, data) => ({ type: T.UPDATE_MEMBER, payload: { teamId, email, data } });
export const updateMemberSuccess = (member) => ({ type: T.UPDATE_MEMBER_SUCCESS, payload: member });
export const removeMember = (teamId, email) => ({ type: T.REMOVE_MEMBER, payload: { teamId, email } });
export const removeMemberSuccess = (email) => ({ type: T.REMOVE_MEMBER_SUCCESS, payload: { email } });

// Created entity navigation flag
export const clearLastCreatedTeam = () => ({ type: T.CLEAR_LAST_CREATED_TEAM });

export const openTeamDialog = (team = null) => ({ type: T.OPEN_TEAM_DIALOG, payload: team });
export const closeTeamDialog = () => ({ type: T.CLOSE_TEAM_DIALOG });
export const openDeleteDialog = (team) => ({ type: T.OPEN_DELETE_DIALOG, payload: team });
export const closeDeleteDialog = () => ({ type: T.CLOSE_DELETE_DIALOG });
export const openDetailDialog = (team) => ({ type: T.OPEN_DETAIL_DIALOG, payload: team });
export const closeDetailDialog = () => ({ type: T.CLOSE_DETAIL_DIALOG });

export const setFilters = (filters) => ({ type: T.SET_FILTERS, payload: filters });
export const setPagination = (pagination) => ({ type: T.SET_PAGINATION, payload: pagination });
export const setSort = (sort) => ({ type: T.SET_SORT, payload: sort });

// Employee options (for member picker)
export const fetchEmployeeOptions = () => ({ type: T.FETCH_EMPLOYEE_OPTIONS });
export const fetchEmployeeOptionsSuccess = (payload) => ({ type: T.FETCH_EMPLOYEE_OPTIONS_SUCCESS, payload });
export const fetchEmployeeOptionsFailure = (error) => ({ type: T.FETCH_EMPLOYEE_OPTIONS_FAILURE, payload: error });
